export default __webpack_public_path__ + "static/media/seiseki2.d483f059.png";